/* ============
 * Actions for the app module
 * ============
 *
 * The actions that are available on the
 * app module.
 */

import * as types from './mutation-types'

export const setSection = ({commit, state}, payload) => {
  const section = payload.section
  if (Object.values(state.appSections).indexOf(section) !== -1) {
    commit(types.SECTION, section)
  } else {
    throw Error('Unknown application section')
  }
}

export default {
  setSection
}



// WEBPACK FOOTER //
// ./src/app/store/modules/app/actions.js